import { useState, useMemo } from "react";

export default function LessonQuiz({ questions }) {
  // ✅ Hooks siempre arriba, sin condiciones
  const safeQuestions = Array.isArray(questions) ? questions : [];
  const [score, setScore] = useState(0);
  const [current, setCurrent] = useState(0);

  const hasQuestions = safeQuestions.length > 0;
  const currentQuestion = useMemo(
    () => (hasQuestions ? safeQuestions[current] : null),
    [hasQuestions, safeQuestions, current]
  );

  if (!hasQuestions) {
    return <div>Sin preguntas</div>;
  }

  const onAnswer = (isCorrect) => {
    if (isCorrect) setScore((s) => s + 1);
    setCurrent((i) => Math.min(i + 1, safeQuestions.length - 1));
  };

  return (
    <div>
      <div>{currentQuestion.text}</div>
      {currentQuestion.options.map((opt) => (
        <button key={opt.id} onClick={() => onAnswer(opt.correct)}>
          {opt.label}
        </button>
      ))}
      <div>Puntaje: {score}</div>
    </div>
  );
}
